import { Command as CommandPackage } from "cmdk";

import { ComponentRepeater } from "@/components/atoms/ComponentRepeater";
import { Skeleton } from "@/components/atoms/Skeleton";

const MainSearchLoading = () => {
  return (
    <CommandPackage.Loading>
      <div className="flex flex-col gap-1 rounded-2xl mt-2 px-1">
        <ComponentRepeater
          component={<Skeleton className="w-full h-9" />}
          count={5}
        />
      </div>
    </CommandPackage.Loading>
  );
};

export default MainSearchLoading;
